// libs
import styled, { css } from 'styled-components'
// components
import Grid from '@mui/material/Grid2'
import { Paper as PaperOrigin, Scrollbar as ScrollbarOrigin } from 'components/UI'

export const Paper = styled((props) => <PaperOrigin {...props} />)`
  && {
    height: calc(100% - 40px);
    padding: 16px 0 16px 16px;
    width: calc(100% - 643px);
    margin: 20px;
    font-size: 16px;
  }
`

export const Wrapper = styled((props) => <Grid {...props} />)`
  && {
    padding-right: 24px;
    font-size: 16px;
  }
`

export const Scrollbar = styled((props) => <ScrollbarOrigin {...props} />)`
  height: calc(100% - 60px);
`

export const ButtonsWrapper = styled('div')<{ isReviewInProgress: boolean }>`
  padding: 16px 0;

  & > div:first-child {
    margin-right: 8px;
  }

  ${({ isReviewInProgress }) =>
    isReviewInProgress &&
    css`
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      width: 316px;
    `}
`
